export const appStyles = {
  loading: "flex h-full items-center justify-center text-xs text-subtle",
};
